(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bienalia-header-editable"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.bn-mobile-menu[open]').forEach(function(menu){if(!menu.contains(event.target)||event.target.closest('.bn-mobile-links a'))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.bn-mobile-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bienalia-purge"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const root=event.target.closest('.bn');if(!root)return;let button=event.target.closest('[data-bn-image]');const thumbs=Array.from(root.querySelectorAll('[data-bn-image]'));if(event.target.closest('.bn-next')){const current=thumbs.findIndex(x=>x.getAttribute('aria-pressed')==='true');button=thumbs[((current<0?0:current)+1)%thumbs.length]}if(!button)return;const hero=root.querySelector('.bn-hero');if(hero){hero.removeAttribute('srcset');hero.src=button.dataset.bnImage;hero.alt=button.getAttribute('aria-label');thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===button)))}});

document.querySelectorAll('[data-review-carousel]').forEach(function(root){
 const cards=Array.from(root.querySelectorAll('[data-review-index]'));const dots=Array.from(root.querySelectorAll('[data-review-start]'));let active=7;let touchX=0;
 function show(index){active=(index+cards.length)%cards.length;const visible=window.matchMedia('(max-width:600px)').matches?1:3;cards.forEach(function(card){const distance=(Number(card.dataset.reviewIndex)-active+cards.length)%cards.length;card.hidden=distance>=visible;card.style.order=distance;});dots.forEach(function(dot){dot.setAttribute('aria-pressed',String(Number(dot.dataset.reviewStart)===active));});}
 root.addEventListener('click',function(e){const dot=e.target.closest('[data-review-start]');if(dot)show(Number(dot.dataset.reviewStart));});
 root.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].clientX;},{passive:true});root.addEventListener('touchend',function(e){const distance=e.changedTouches[0].clientX-touchX;if(Math.abs(distance)>45)show(active+(distance<0?1:-1));},{passive:true});
 root.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1));}});window.addEventListener('resize',function(){show(active);});show(active);
});

document.querySelectorAll('[data-demo-reviews]').forEach(function(root){const cards=Array.from(root.querySelectorAll('.bn-demo-card'));const filter=root.querySelector('[data-demo-filter]');const prev=root.querySelector('[data-demo-prev]');const next=root.querySelector('[data-demo-next]');let page=0;function render(){const selected=cards.filter(c=>filter.value==='all'||c.dataset.demoRating===filter.value);const pages=Math.max(1,Math.ceil(selected.length/6));page=Math.max(0,Math.min(page,pages-1));cards.forEach(c=>c.hidden=true);selected.slice(page*6,page*6+6).forEach(c=>c.hidden=false);root.querySelector('[data-demo-page]').textContent='Página '+(page+1)+' de '+pages;root.querySelector('[data-demo-count]').textContent=selected.length+' ejemplos simulados';prev.disabled=page===0;next.disabled=page===pages-1;}filter.addEventListener('change',function(){page=0;render();});prev.addEventListener('click',function(){page--;render();});next.addEventListener('click',function(){page++;render();});const link=root.querySelector('.bn-demo-write');link.addEventListener('click',function(){root.querySelector('.bn-demo-form').open=true;});render();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-garantia"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){if(!event.target.closest('[data-bn-promise-panel-buy]'))return;const buy=document.querySelector('.bn-main .bn-buy');if(buy&&!buy.disabled)buy.click();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
